var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMypageInquiry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6811 2.87858C14.2039 3.66095 14.2039 4.75007 14.2039 6.92832C14.2039 9.10657 14.2039 10.1957 13.6811 10.9781C13.4548 11.3168 13.164 11.6076 12.8253 11.8339C12.1418 12.2906 11.2243 12.3483 9.55101 12.3556V12.3566L8.69366 14.0713C8.40788 14.6429 7.59224 14.6429 7.30645 14.0713L6.44911 12.3566V12.3556C4.77587 12.3483 3.85831 12.2906 3.17484 11.8339C2.83614 11.6076 2.54534 11.3168 2.31903 10.9781C1.79626 10.1957 1.79626 9.10657 1.79626 6.92832C1.79626 4.75007 1.79626 3.66095 2.31903 2.87858C2.54534 2.53988 2.83614 2.24907 3.17484 2.02276C3.95721 1.5 5.04634 1.5 7.22458 1.5H8.77553C10.9538 1.5 12.0429 1.5 12.8253 2.02276C13.164 2.24907 13.4548 2.53988 13.6811 2.87858Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67358 5.37695L10.3264 5.37695",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67358 8.47949H8.00001",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMypageInquiry);
export default __webpack_public_path__ + "static/media/icon_mypage_inquiry.7a91ba80c2b6cc4b0f318fafc6227e29.svg";
export { ForwardRef as ReactComponent };